/**
 * 拉流播放器模块
 * @author lianghua.fu
 * @date 2019-11-21 16:45:07
 */
$.namespace(
  'MemePlayer',
  $.Class(function () {
    var tmplPlayer =
      '<div class="ui-player-inner <%= position %>">\
        <div class="ui-player-video"></div>\
        <div class="ui-player-loading"></div>\
        \
        <div class="ui-player-flash-allow" style="display:none;">\
            <a href="javascript:;">下载或允许 Flash 播放器</a>\
        </div>\
    </div>';
    var tmplSetting =
      '<div class="ui-player-setting <%= position %>">\
        <div class="ui-player-volume ui-player-tip <%=volumeControl?\'\':\'hide\'%>" title="设置音量">\
            <div class="ui-player-volume-bar">\
                <div class="ui-player-volume-bar-process"></div>\
                <div class="ui-player-volume-bar-dot"></div>\
            </div>\
        </div>\
        <a href="javascript:;" title="静音" data-log="event=player&event_type=muted&desc=静音" class="ui-player-control ui-player-muted ui-player-tip <%=mutedControl?\'\':\'hide\'%>"><i class="iconfont icon-mute-on"></i><i class="iconfont icon-mute-off"></i></a>\
        <a href="javascript:;" title="切换播放器" data-log="event=player&event_type=switch&desc=切换播放器" class="ui-player-control ui-player-switch ui-player-tip <%=switchControl?\'\':\'hide\'%>"><i class="iconfont icon-copy-line"></i></a>\
        <a href="javascript:;" title="刷新视频" data-log="event=player&event_type=reload&desc=刷新视频" class="ui-player-control ui-player-reload ui-player-tip <%=reloadControl?\'\':\'hide\'%>"><i class="iconfont icon-refresh-line"></i></a>\
        <!--<a style="display:none;" href="javascript:;" title="截图" class="ui-player-control ui-player-snapshot ui-player-tip"><i class="iconfont icon-xiangjixianxing"></i></a>-->\
        </div>';

    this.playerType = '';
    // this.player = null;
    this.current = null;

    /**
     *
     * @param $dom / options {Object}
     * @param roomId
     * @param url
     *
     * @param options {Object}
     * {
     *     $dom,
     *     roomId,
     *     url,    可选
     *     volume, 可选 {0-1}  ，默认0.7   0 静音,
     *     urlLoader({flv_url,hls_url,rtmp_url})
     * }
     */
    this.init = function ($dom, roomId, url) {
      var defaultOpts = {
        volume: 0.7,
        // 控件是否显示
        switchControl: false, // 切换视频
        mutedControl: true, // 静音按钮
        reloadControl: true, // 刷新视频按钮
        volumeControl: true, // 音量控制

        position: '', // half-left half-right

        objectFit: 'contain', // fill contain cover  none  scale-down
        playerType: 'flv', // 关闭flash模式播放
      };
      var options = {
        $dom: $dom,
        roomId: roomId,
        url: url,
      };
      if ($.isPlainObject($dom)) {
        options = $dom;
      }

      options = _.assign({}, defaultOpts, options);

      MM.core.debug('player init options:', options);

      this.$dom = options.$dom.addClass('ui-player');
      this.options = options;
      if (options.playerType) {
        this.playerType = options.playerType;
      }
      this.play(options.roomId, options.url);
    };

    this.play = function (roomId, url) {
      if (this.current) {
        var volume = this.current.controller.getVolume();
        MM.core.debug('play volume', volume);
        this.options.volume = volume;
      }

      this.destroy();
      this.roomId = roomId;
      this.url = url;
      this.options.roomId = roomId;
      this.options.url = url;
      this.options.$player = $($.template(tmplPlayer, this.options));
      this.options.$playerSetting = $($.template(tmplSetting, this.options));
      // this.$container = $($.template(tmplSetting,this.options));
      this.$dom.append(this.options.$player);
      this.$dom.append(this.options.$playerSetting);
      this._initPlayer();
    };

    this._initPlayer = function () {
      this._initPlayerType();

      this.options.$playerSetting
        .find('.ui-player-switch')
        .attr(
          'title',
          this.playerType === 'flash'
            ? '切换到 flv 播放器'
            : '切换到 flash 播放器',
        );
      var Player = this.getPlayerClass();

      this.current = new Player(this, this.options);
    };

    /**
     * 设置视频的位置
     * @param position [full,left,right]
     */
    this.setPosition = function (position) {
      var p =
        { full: '', right: 'half-right', left: 'half-left' }[position] || '';
      if (this.options.$player) {
        this.options.$player.removeClass('half-left half-right').addClass(p);
      }
    };

    this.getPlayerClass = function () {
      return MemeFlvPlayer;
    };

    this.switchPlayerType = function (type) {
      MM.core.debug('player switchPlayerType');
      if (!type) {
        type = this.playerType === 'flash' ? 'flv' : 'flash';
      }
      this._savePlayerType(type);
      this.play(this.roomId);
    };

    this.destroy = function () {
      this.current && this.current.destroy();
    };

    var CACHE_KEY = 'MEME_PLAYER_TYPE';
    this._initPlayerType = function () {
      if (this.playerType) {
        return this.playerType;
      }

      if (window.FLV_CONFIG && FLV_CONFIG.cache_key) {
        CACHE_KEY = FLV_CONFIG.cache_key;
      }

      var playerType = $.store.get(CACHE_KEY);

      if (!playerType) {
        var enableFlv = false;
        var roomIdSuffix = parseInt((this.roomId + '').slice(-1));
        if (
          window.FLV_CONFIG &&
          FLV_CONFIG.is_flv_player &&
          (!FLV_CONFIG.room_ids.length ||
            FLV_CONFIG.room_ids.indexOf(roomIdSuffix) > -1)
        ) {
          enableFlv = true;
        }

        if (flvjs.isSupported() && enableFlv) {
          playerType = 'flv';
        } else {
          playerType = 'flash';
        }
        MM.core.debug('player init type:', playerType, 'enableFlv:', enableFlv);
      }

      this._savePlayerType(playerType);
    };

    this._savePlayerType = function (type) {
      this.playerType = type;
      $.store.set(CACHE_KEY, type);
    };
  }),
);
